<template>
  <div>
    <b-tabs
      size="is-small"
      vertical
      :animated="false"
      v-model="activeTab"
      @input="tabChange"
      class="grip-analysis-sidebar-tab"
      type="is-boxed"
    >
      <b-tab-item>
        <template #header>
          <div class="tab-header" @click="openSideNav('library')">
            <img
              width="24px"
              :src="
                require(activeTab === tabList.indexOf('library')
                  ? '/src/assets/icons/ic_edit_library_blue.png'
                  : '/src/assets/icons/ic_edit_library_white.png')
              "
            />
            <p>Edit Library</p>
          </div>
        </template>
      </b-tab-item>
      <b-tab-item>
        <template #header>
          <div class="tab-header" @click="openSideNav('criteria')">
            <img
              width="24px"
              :src="
                require(activeTab === tabList.indexOf('criteria')
                  ? '/src/assets/icons/ic_criteria_blue.png'
                  : '/src/assets/icons/ic_criteria_white.png')
              "
            />
            <p>Criteria</p>
          </div>
        </template>
        <ExistingCriteriaList
          :key="criteriaTabKey"
          :class="
            isSideBarCollapsed ? $style.openContainer : $style.closeContainer
          "
          :projectId="projectId"
          :analysisCriteriaIds="analysisCriteriaIds"
          :isGripAnalysis="isGripAnalysis"
          @updateSelectedCriteria="handleSelectedCriteria"
          @collapseSideNav="closeSideNav()"
        />
      </b-tab-item>
      <b-tab-item>
        <template #header>
          <div class="tab-header" @click="openSideNav('barrier')">
            <img
              width="24px"
              :src="
                require(activeTab === tabList.indexOf('barrier')
                  ? '/src/assets/icons/ic_barrier_blue.png'
                  : '/src/assets/icons/ic_barrier_white.png')
              "
            />
            <p>Barrier</p>
          </div>
        </template>
        <ExistingGripBarrierList
          :key="barrierTabKey"
          :class="
            isSideBarCollapsed ? $style.openContainer : $style.closeContainer
          "
          :projectId="projectId"
          @collapseSideNav="closeSideNav()"
        />
      </b-tab-item>
      <b-tab-item>
        <template #header>
          <div class="tab-header" @click="openSideNav('enabler')">
            <img
              width="24px"
              :src="
                require(activeTab === tabList.indexOf('enabler')
                  ? '/src/assets/icons/ic_enabler_blue.png'
                  : '/src/assets/icons/ic_enabler_white.png')
              "
            />
            <p>Enabler</p>
          </div>
        </template>
        <ExistingGripEnablerList
          :key="enablerTabKey"
          :class="
            isSideBarCollapsed ? $style.openContainer : $style.closeContainer
          "
          :projectId="projectId"
          @collapseSideNav="closeSideNav()"
        />
      </b-tab-item>
      <b-tab-item>
        <template #header>
          <div class="tab-header" @click="openSideNav('strategy')">
            <img
              width="24px"
              :src="
                require(activeTab === tabList.indexOf('strategy')
                  ? '/src/assets/icons/ic_strategy_blue.png'
                  : '/src/assets/icons/ic_strategy_white.png')
              "
            />
            <p>Strategy</p>
          </div>
        </template>
        <ExistingGripStrategyList
          :key="strategyTabKey"
          :class="
            isSideBarCollapsed ? $style.openContainer : $style.closeContainer
          "
          :projectId="projectId"
          @collapseSideNav="closeSideNav()"
        />
      </b-tab-item>
    </b-tabs>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseLoading from '../../../components/base/BaseLoading.vue';
import ExistingCriteriaList from './ExistingCriteriaList.vue';
import ExistingGripBarrierList from './ExistingGripBarrierList.vue';
import ExistingGripEnablerList from './ExistingGripEnablerList.vue';
import ExistingGripStrategyList from './ExistingGripStrategyList.vue';
const tabList: string[] = [
  'library',
  'criteria',
  'barrier',
  'enabler',
  'strategy',
];
@Component({
  components: {
    BaseLoading,
    ExistingCriteriaList,
    ExistingGripBarrierList,
    ExistingGripEnablerList,
    ExistingGripStrategyList,
  },
})
export default class GripAnalysisSideBar extends Vue {
  @Prop() public projectId!: number;
  @Prop() public analysisCriteriaIds!: number[];
  @Prop() public isGripAnalysis!: boolean;
  @Prop() public isSideBarOpen!: boolean;
  @Prop() public activeSidebarTab!: number;

  public isLoading: boolean = true;
  public isSideBarCollapsed: boolean = false;
  public activeTab: number = this.activeSidebarTab ? this.activeSidebarTab : 1;
  public criteriaTabKey: number = Math.floor(Math.random() * 999);
  public barrierTabKey: number = Math.floor(Math.random() * 999);
  public enablerTabKey: number = Math.floor(Math.random() * 999);
  public strategyTabKey: number = Math.floor(Math.random() * 999);

  get tabList() {
    return tabList;
  }

  public tabChange(): void {
    switch (this.activeTab) {
      case tabList.indexOf('criteria'):
        this.criteriaTabKey += 1;
        break;
      case tabList.indexOf('barrier'):
        this.barrierTabKey += 1;
        break;
      case tabList.indexOf('enabler'):
        this.enablerTabKey += 1;
        break;
      case tabList.indexOf('strategy'):
        this.strategyTabKey += 1;
        break;
      default:
        break;
    }

    if (this.activeTab !== tabList.indexOf('library')) {
      this.$emit('updateActiveSidebarTab', this.activeTab);
    }
  }

  public mounted(): void {
    this.isSideBarCollapsed = this.isSideBarOpen ? this.isSideBarOpen : false;
  }

  public handleSelectedCriteria(data: {
    selectedCriteriaIds: number[];
    update: boolean;
  }): void {
    this.$emit('updateSelectedCriteria', data);
  }

  public openSideNav(tabValue: string): void {
    if (!this.isSideBarCollapsed) {
      this.isSideBarCollapsed = true;
      this.$emit('collapseSideNav', this.isSideBarCollapsed);
    }

    if (tabValue === 'library') {
      this.closeSideNav();
      window.open(`/projects/${this.projectId}#settings-grip`, '_blank');
    }
  }

  public closeSideNav(): void {
    this.isSideBarCollapsed = false;
    this.$emit('collapseSideNav', this.isSideBarCollapsed);
  }
}
</script>
<style lang="scss" module>
.openContainer {
  padding: 40px 24px;
  width: 100%;
}

.closeContainer {
  display: none;
}
</style>
